import { Image } from "./image";
import React from "react";
import {Helmet} from "react-helmet";

export const Gallery = (props) => {
  return (
    <>
    <Helmet>
      <title>MGM Saúde e Estética Avançada</title>
      <meta name="description" content="Clínica de Estética em Copacabana, Rio de Janeiro especializada em correção das orelhas de abano, bioestimuladores, drenagem linfática, enzimas contra celulite e gordura localizada, fios de PDO, harmonização de glúteos, massagem modeladora, microagulhamento, preenchimento labial, subcisão, terapia capilar e toxina botulínica, Destaca-se pelo atendimento onde cada paciente recebe um protocolo de tratamento individualizado." />
    </Helmet>
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <p>CONFIRA AQUI NOSSOS</p>
          <h2>Procedimentos Estéticos</h2>  
          <p>
            Veja nosso portfólio de resultados no <a href="https://www.instagram.com/clinica.mgm" target="_blank" rel="noreferrer">Instagram  <i className="fa fa-instagram"></i></a>
          </p>  
        </div>     

        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      image={d.image}
                      description={d.description}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>        

        <div className="portfolio-btn">
          <a href="https://api.whatsapp.com/send?phone=5521980366885&text=Ol%C3%A1,%20vi%20a%20p%C3%A1gina%20da%20cl%C3%ADnica%20e%20gostaria%20de%20agendar%20uma%20consulta." className="btn btn-custom btn-lg page-scroll" target="_blank" rel="noreferrer">
          Agendar Consulta <i className="fa fa-whatsapp"></i>
          </a>{" "}
        </div>        
        
      </div>
    </div>
    </>
  );
};
